'use client';

import { atom } from 'jotai';

export type AdWidthType = 'mobile' | 'tabletAndDesktop';

export const adWidthAtom = atom<AdWidthType | undefined>(undefined);
